module.exports = __webpack_public_path__ + "img/icon_pencil.66951000.svg";